// --- The Sixth House Collective: No Zoom Lightbox for Craft Theme ---
document.addEventListener('DOMContentLoaded', () => {
  const productImages = document.querySelectorAll('.product__media img, .media img');

  productImages.forEach(img => {
    img.style.cursor = 'pointer';
    img.addEventListener('click', () => {
      const modal = document.createElement('div');
      modal.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
      `;

      const clone = img.cloneNode();
      clone.style.cssText = `
        max-width: 90%;
        max-height: 90%;
        object-fit: contain;
        cursor: default;
        box-shadow: 0 0 20px rgba(0,0,0,0.6);
      `;

      modal.appendChild(clone);
      document.body.appendChild(modal);

      // Cerrar al hacer clic fuera de la imagen
      modal.addEventListener('click', () => modal.remove());
    });
  });
});
